import Http from './http.init'
import HttpStat from './http-stats.init'
import { ResponseWrapper, ErrorWrapper } from './util'

export default class BaseService {
  constructor () {
    if (!this.entity) {
      throw new Error('Child service class not provide entity')
    }
  }

  getEntity(entityName) {
    
  }

  /**
   * ------------------------------
   * @HELPERS
   * ------------------------------
   */

  request (status = { auth: false }) {
    return new Http(status)
  }

  statRequest (status = { auth: false }) {
    return new HttpStat(status)
  }

  responseWrapper (...rest) {
    return new ResponseWrapper(...rest)
  }

  errorWrapper (...rest) {
    return new ErrorWrapper(...rest)
  }

  getByDatesAndProject(parameters = {}) {
    const params = {
      ...parameters
    }
    return new Promise((resolve, reject) => {
      var auth = {
        
      }
      //dates?timezone=Europe%2FMoscow
      return this.statRequest().get(`day-aggr?timezone=Europe%2FMoscow&from_date=`+params.from+`&to_date=`+params.to+`&project_id=`+params.id, {
        auth:{
          username:'swagger',//todo set up a task to push it from the env
          password:'pheec3EiauGh6iGh'
        }
        })
      //return this.statRequest().get(`day-aggr?timezone=Europe%2FMoscow&from_date=2019-06-15&to_date=2019-06-16&project_id=223`, {  })
      //return this.statRequest().get(`dates?timezone=Europe%2FMoscow`, { 
        
        .then(response => {
          
          let data = {
            content: response,
            total: response
          }
          
          resolve(this.responseWrapper(response, response.data))
        }).catch(error => {
          //let message = error.response.data ? error.response.data.error : error.response.statusText
          //reject(this.errorWrapper(error, message))
        })
    })
  }

  getByErrors(parameters = {}) {
    return new Promise((resolve, reject) => {
      //dates?timezone=Europe%2FMoscow
      return this.statRequest().get(`error-categories-day-aggr?date=2019-05-28&timezone=Europe/Moscow`, {  })
      //return this.statRequest().get(`dates?timezone=Europe%2FMoscow`, { 
        
        .then(response => {
          let data = {
            content: response.data.data.results,
            total: response.data.data.total
          }
          resolve(this.responseWrapper(response, data))
        }).catch(error => {
          //let message = error.response.data ? error.response.data.error : error.response.statusText
          //reject(this.errorWrapper(error, message))
        })
    })
  }

  /**
   * ------------------------------
   * @API_CALLS_PUBLIC
   * ------------------------------
   */

  getListPublic (parameters = {}) {
    const params = {
      ...parameters
    }
    return new Promise((resolve, reject) => {
      return this.request().get(`${this.entity}`, { params })
        .then(response => {
          let data = {
            content: response.data.data.results,
            total: response.data.data.total
          }
          resolve(this.responseWrapper(response, data))
        }).catch(error => {
          let message = error.response.data ? error.response.data.error : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  getByIdPublic (id = window.required()) {
    return new Promise((resolve, reject) => {
      return this.request().get(`${this.entity}/${id}`)
        .then(response => resolve(this.responseWrapper(response, response.data.data)))
        .catch(error => {
          let message = error.response.data ? error.response.data.error : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  /**
   * ------------------------------
   * @API_CALLS_PRIVATE
   * ------------------------------
   */

  getById (id = window.required()) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get(`${this.entity}/${id}`)
        .then(response => resolve(this.responseWrapper(response, response.data.data)))
        .catch(error => {
          let message = error.response.data ? error.response.data.error : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  create (data = window.required()) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post(`${this.entity}`, data)
        .then(response => resolve(this.responseWrapper(response, response.data.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  update (id = window.required(), data = window.required()) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).patch(`${this.entity}/${id}`, data)
        .then(response => resolve(this.responseWrapper(response, response.data.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  remove (id = window.required()) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).delete(`${this.entity}/${id}`)
        .then(response => resolve(this.responseWrapper(response, response.data.data)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  fetchProjects(parameters ={}) {
    const params = {
      ...parameters
    }
    return new Promise((resolve, reject) => {
      return this.request({auth:true}).get('users/current/projects', { params: params })
        .then(response => {
          let data = {
            content: response,
            total: response.length
          }
          resolve(this.responseWrapper(response, data))
        }).catch(error => {
          let message = error.response.data ? error.response.data.error : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }
}
